import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { configs } from '../../../constants/configs/configs';

function BackToDashboard() {

    return (
        <span className="usa-width-one-whole back-to-dashboard">
            <Link className="usa-width-one-whole border-link" to={ configs.routes.INDPORTAL }>
                <FontAwesomeIcon icon="caret-left" size="1x" className="icon-link"/>
                <FormattedMessage id="dashboard.back.link" />
            </Link>
        </span>
    );
}

export default BackToDashboard;